import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { blue, carbon } = colorsPalettes;

export const ViewerBannerContainer = styled(FlexRow)`
    background: ${blue[100]};
    padding: 24px;
    gap: 20px;
    border-radius: 6px;
    align-items: center;
    margin-bottom: 24px;
    ${setFontVariant("subtitle1", carbon[400])};
`;
